// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * This is a helper method that turn the colors dictionary into dropdown options
 * @param colors
 */
export const getAllColorsAsDropdownOptions = (colors: any) => {
    const options = [] as any;
    for (const key in colors) {
        for (const subkey in colors[key]) {
            if (subkey.toLowerCase().indexOf("contrast") === -1) {
                options.push({ displayName: `${key}.${subkey}`, value: `${key}.${subkey}` });
            }
        }
    }
    return options;
};
